import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import { BLOG_POSTS } from "../data/blog";

export default function BlogListPage() {
  return (
    <>
      <Seo
        title="Blog BEAUTIX Katowice — Paznokcie, Podologia, Kosmetyka Twarzy"
        description="Blog SEO Studia BEAUTIX Katowice: manicure hybrydowy, wrastające paznokcie, Kobido, mezoterapia mikroigłowa. Praktyczna wiedza od zespołu salonu."
        keywords="blog kosmetyczny Katowice, manicure porady, podolog blog, kosmetyka twarzy porady"
        path="/blog"
      />
      <section className="max-w-7xl mx-auto px-6 md:px-10 pt-8 pb-4">
        <Breadcrumbs items={[{ label: "Blog" }]} />
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <p className="eyebrow mb-4">Blog BEAUTIX</p>
        <h1 className="font-serif-display text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight max-w-3xl">
          Wiedza prosto z gabinetu w Katowicach.
        </h1>
        <p className="mt-8 max-w-2xl text-lg text-[var(--beautix-muted)] leading-relaxed font-light">
          Piszemy o tym, o co pytacie w salonie — bez marketingowej bajki,
          z pełnym szacunkiem dla Waszego czasu i pieniędzy.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {BLOG_POSTS.map((p, i) => (
            <Link
              to={`/blog/${p.slug}`}
              key={p.slug}
              data-testid={`blog-card-${p.slug}`}
              className="group flex flex-col border border-[var(--beautix-line)] bg-white hover:border-[var(--beautix-pink)] transition-colors"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={p.image}
                  alt={p.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  loading={i < 2 ? "eager" : "lazy"}
                />
              </div>
              <div className="p-8 flex flex-col gap-4 flex-1">
                <span className="eyebrow">{p.category}</span>
                <h2 className="font-serif-display text-2xl md:text-[1.65rem] leading-tight group-hover:text-[var(--beautix-pink)] transition-colors">
                  {p.title}
                </h2>
                <p className="text-sm text-[var(--beautix-muted)] leading-relaxed line-clamp-3">
                  {p.excerpt}
                </p>
                <div className="mt-auto flex items-center justify-between text-xs text-[var(--beautix-muted)] pt-6 border-t border-[var(--beautix-line)]">
                  <span>{new Date(p.date).toLocaleDateString("pl-PL")}</span>
                  <span>{p.readMin} min czytania</span>
                </div>
                <span className="inline-flex items-center gap-2 text-sm font-medium text-[var(--beautix-pink)]">
                  Czytaj artykuł
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" strokeWidth={1.5} />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
